import LayoutProgress from 'core/layout/LayoutProgress';
import PropTypes from 'prop-types';
import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import ConfigureCourse from 'core/modules/components/general/ConfigureCourse';
import HeaderInfoCourse from 'core/modules/components/general/HeaderInfoCourse';
import React from 'react';
import { withTranslation } from 'react-i18next';

const DialogConfigureCourse = ({
  t,
  open,
  onClose,
  name,
  classroomName,
  level,
  classroomIcon,
  classroomGradient,
  guid,
  courseTimetable,
  changeTimetable,
  courseTimeUnitCurrent,
  onEnd,
  configuration,
  timesUnit,
  picture,
  configProgramPicture,
  enableAdvancedProgramming,
  course,
  hasEvaluationPeriod,
}) => {
  return (
    <Dialog
      ariaLabel={t('course:Configure course')}
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={t('actions:Exit edit mode')}
      className={'dialog-configure-course'}
      isCloseButtonHidden
      isOpen={open}
      onClose={onClose}
      size="all-screen"
    >
      <LayoutProgress
        isMainLandmark={false}
        onEnd={onEnd}
        iconTypeRight="close"
        onClickIconTypeRight={onClose}
        header={
          <div className="dialog-configure-course__header">
            <HeaderInfoCourse
              name={name}
              classroomName={classroomName}
              level={level}
              icon={classroomIcon}
              gradient={classroomGradient}
              picture={picture}
              configProgramPicture={configProgramPicture}
            />
          </div>
        }
      >
        <ConfigureCourse
          configuration={configuration}
          changeTimetableToSave={changeTimetable}
          courseTimetable={courseTimetable}
          courseTimeUnitCurrent={courseTimeUnitCurrent}
          timesUnit={timesUnit}
          enableAdvancedProgramming={enableAdvancedProgramming}
          course={course}
          hasEvaluationPeriod={hasEvaluationPeriod}
        />
      </LayoutProgress>
    </Dialog>
  );
};

DialogConfigureCourse.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  name: PropTypes.string,
  level: PropTypes.string,
  classroomIcon: PropTypes.string,
  classroomGradient: PropTypes.string,
  guid: PropTypes.string,
  courseTimetable: PropTypes.array,
  changeTimetable: PropTypes.func,
  courseTimeUnitCurrent: PropTypes.object,
  onEnd: PropTypes.func,
  configuration: PropTypes.object,
  timesUnit: PropTypes.array,
  picture: PropTypes.string,
  configProgramPicture: PropTypes.string,
  enableAdvancedProgramming: PropTypes.bool,
  course: PropTypes.object,
  hasEvaluationPeriod: PropTypes.bool,
  classroomName: PropTypes.string,
  t: PropTypes.func,
};

DialogConfigureCourse.defaultProps = {
  onClose: function () {},
  open: false,
  t: function () {},
};

export default withTranslation(['lesson', 'actions', 'common'])(DialogConfigureCourse);
